import React from 'react';
import { SRow, SCol } from '@avalara/skylab-sdk/react';
import Banner from '../../styled/components/single-column-banner';
const ThankYouBanner = () => (React.createElement(Banner, { orange: true, role: 'complementary' },
    React.createElement(SRow, { className: 'align-items-center' },
        React.createElement(SCol, { span: '12', center: '', className: 'pad-bottom-none' },
            React.createElement("h1", { className: 'text-white text-xxl font-normal', "data-ref": 'returns.thankyou-header' }, "Thanks for purchasing Avalara Returns")))));
export default ThankYouBanner;
